import React, {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';

import {
  loyaltyAgreementSelector,
  agreementAcceptanceRequest,
  userSettingDataSelector,
  termsPageRequest,
  loyaltyAgreementDocSelector,
} from '@ibibo/myaccount-reducer';

import * as S from './SelectT&C.styles';
import Modal from '../../../../shared/Modal/Modal';

const SelectTnC = ({
  navigationSec,
  heading,
  subHeading,
  benefitsHeading,
  benefits,
  exstngAgrmntHeading,
  exstngAgrmnt,
  newAgrmntHeading,
  newAgrmnt,
  exstngAgrmntBtn,
  newAgrmntBtn,
  selectExstngAgrmnt,
  handlePageChange,
  pageIndex,
  showEmail = false,
}) => {
  const dispatch = useDispatch();
  const winSize = window.screen.width;

  const loyaltyAgreementDate = useSelector(loyaltyAgreementSelector);
  const userData = useSelector(userSettingDataSelector);
  const loyaltyAgreementDoc = useSelector(loyaltyAgreementDocSelector);

  const equalHeights = className => {
    let findClass = document.getElementsByClassName(className);
    // console.log(findClass);
    let tallest = 0;
    // Loop over matching divs
    for (let i = 0; i < findClass.length; i++) {
      let ele = findClass[i];
      let eleHeight = ele.offsetHeight;
      tallest = eleHeight > tallest ? eleHeight : tallest;
    }
    for (let i = 0; i < findClass.length; i++) {
      findClass[i].style.height = tallest + 'px';
    }
  };
  useEffect(() => {
    equalHeights('equalHeight');
    equalHeights('equalHeight0');
    equalHeights('equalHeight1');
    equalHeights('equalHeight2');
    equalHeights('equalHeight3');
    equalHeights('equalHeight4');
    // equalHeights('cardHeight');
    //console.log('test inside the trap');
  });

  const submitHandlerForTertiaryButton = actionValue => {
    if (actionValue === 'Agree and Continue') {
      //handlePageChange('old-agreement-acknowledged-page');
    } else if (actionValue === 'Verify Later') {
      window.open('http://mypartner.makemytrip.com/', '_self');
    } else {
    }
  };

  const submitHandlerOldAgreementContinue = () => {
    handlePageChange('existing-agreement-confirmation-page');
  };

  const submitHandlerNewAgreementContinue = () => {
    handlePageChange('new-agreement-confirmation-page');
  };

  const submitHandlerForPrimaryButton = actionValue => {
    if (actionValue === 'Agree and Continue') {
      const data = true;
      dispatch(
        agreementAcceptanceRequest(
          data,
          selectAgreementSuccessCallback,
          selectAgreementErrorCallback,
        ),
      );
    } else {
      handlePageChange('select-agreement-page');
    }
  };

  const getTerminationContract = () => {
    window.open('/myterminationagreement/', '_blank');
  };

  const getLoyaltyAgreementContract = () => {
    window.open('/myloyaltyagreement/', '_blank');
  };

  const handleSettingsRedirection = () => {
    window.open('/mysettings/', '_self');
  };

  const selectAgreementSuccessCallback = () => {
    handlePageChange('new-agreement-acknowledged-page');
  };

  const selectAgreementErrorCallback = () => {};

  return (
    <S.styledDiv
      className={`selectTnCWrap ${navigationSec ? 'navigationSec' : ''} ${
        winSize < 767 ? 'mobile' : ''
      }`}
    >
      {navigationSec && <NavigationSection {...navigationSec} />}
      {heading && <p className="heading" dangerouslySetInnerHTML={{__html: heading}} />}
      {subHeading && <p className="subHeading" dangerouslySetInnerHTML={{__html: subHeading}} />}
      {(benefitsHeading ||
        benefits ||
        exstngAgrmnt ||
        exstngAgrmntHeading ||
        exstngAgrmntBtn ||
        newAgrmnt ||
        newAgrmntBtn ||
        newAgrmntHeading) && (
        <div className="selectTnC-content">
          <div className="benefits cardHeight">
            <p className="equalHeight">{benefitsHeading}</p>
            {benefits &&
              benefits.length > 0 &&
              benefits.map((itm, index) => (
                <p key={index} className={`makeFlex hrtlCenter equalHeight${index}`}>
                  {itm}
                </p>
              ))}
          </div>
          {winSize > 767 ? (
            <div className="exstngAgrmnt cardHeight">
              <p className="equalHeight">{exstngAgrmntHeading}</p>
              <div className="exstngAgrmnt-contnt">
                {exstngAgrmnt &&
                  exstngAgrmnt.length > 0 &&
                  exstngAgrmnt.map((itm, index) => (
                    <p key={index} className={`makeFlex vrtlCenter hrtlCenter equalHeight${index}`}>
                      {itm === 'false' ? (
                        <span className="agrmntSprite agrmntSprite--crossIcon"></span>
                      ) : (
                        itm
                      )}
                    </p>
                  ))}
                {exstngAgrmntBtn && (
                  <button onClick={submitHandlerOldAgreementContinue} className="exstngAgrmntBtn">
                    {exstngAgrmntBtn.title}
                  </button>
                )}
              </div>
            </div>
          ) : (
            <div className="makeFlex column appendLeft8">
              <div className="exstngAgrmnt cardHeight">
                <p className="equalHeight">{exstngAgrmntHeading}</p>
                {exstngAgrmnt &&
                  exstngAgrmnt.length > 0 &&
                  exstngAgrmnt.map((itm, index) => (
                    <p key={index} className={`makeFlex vrtlCenter hrtlCenter equalHeight${index}`}>
                      {itm === 'false' ? (
                        <span className="agrmntSprite agrmntSprite--crossIcon"></span>
                      ) : (
                        itm
                      )}
                    </p>
                  ))}
              </div>
              {exstngAgrmntBtn && (
                <button onClick={submitHandlerOldAgreementContinue} className="exstngAgrmntBtn">
                  {exstngAgrmntBtn.title}
                </button>
              )}
            </div>
          )}
          {winSize > 767 ? (
            <div className="newAgrmnt cardHeight">
              <p className="equalHeight">{newAgrmntHeading}</p>
              <span className="infoTag">New</span>
              {newAgrmnt &&
                newAgrmnt.length > 0 &&
                newAgrmnt.map((itm, index) => (
                  <p
                    key={index}
                    className={`font14 latoBlack blackText makeFlex vrtlCenter hrtlCenter equalHeight${index}`}
                  >
                    {itm === 'true' ? (
                      <span className="agrmntSprite agrmntSprite--tickIcon"></span>
                    ) : (
                      itm
                    )}
                  </p>
                ))}
              {newAgrmntBtn && (
                <button
                  onClick={submitHandlerNewAgreementContinue}
                  className="primaryBtn newAgrmntBtn"
                >
                  {newAgrmntBtn.title}
                </button>
              )}
            </div>
          ) : (
            <div className="makeFlex column appendLeft8">
              <div className="newAgrmnt cardHeight">
                <p className="equalHeight">{newAgrmntHeading}</p>
                <span className="infoTag">New</span>
                {newAgrmnt &&
                  newAgrmnt.length > 0 &&
                  newAgrmnt.map((itm, index) => (
                    <p
                      key={index}
                      className={`font14 latoBlack blackText makeFlex vrtlCenter hrtlCenter equalHeight${index}`}
                    >
                      {itm === 'true' ? (
                        <span className="agrmntSprite agrmntSprite--tickIcon"></span>
                      ) : (
                        itm
                      )}
                    </p>
                  ))}
              </div>
              {newAgrmntBtn && (
                <button
                  onClick={submitHandlerNewAgreementContinue}
                  className="primaryBtn newAgrmntBtn"
                >
                  {newAgrmntBtn.title}
                </button>
              )}
            </div>
          )}
        </div>
      )}
      {selectExstngAgrmnt && (
        <div className="selectExstngAgrmnt">
          {selectExstngAgrmnt.imgObj && <></>}
          {selectExstngAgrmnt.title && (
            <p className="selectExstngAgrmnt-title">
              {selectExstngAgrmnt.title} {showEmail ? userData?.email?.value : ''}
            </p>
          )}
          {selectExstngAgrmnt?.subtitle && (
            <p className="selectExstngAgrmnt-subtitle">{selectExstngAgrmnt?.subtitle}</p>
          )}
          {selectExstngAgrmnt.benefits && (
            <p className="margin-class">
              <p className="benefitsTitle">
                You will be <span className="latoBlack">losing out on the following benefits!</span>
              </p>
              <ul
                className={`selectExstngAgrmnt-benefits ${
                  selectExstngAgrmnt.agreeStatement ? '' : 'appendBottom65'
                }`}
              >
                {selectExstngAgrmnt.benefits.length > 0 &&
                  selectExstngAgrmnt.benefits.map((itm, index) => (
                    <li key={index}>
                      <span className={`${itm.icon} appendRight10`}></span>
                      <span className="font14 lineHeight18 darkGreyText">{itm.text}</span>
                    </li>
                  ))}
              </ul>
            </p>
          )}
          {selectExstngAgrmnt.newBenefits && (
            <>
              <ul
                className={`selectExstngAgrmnt-benefits paddingTB10 ${
                  winSize < 767 ? (selectExstngAgrmnt.agreeStatement ? 'appendBottom30' : '') : ''
                }`}
              >
                {selectExstngAgrmnt.newBenefits.length > 0 &&
                  selectExstngAgrmnt.newBenefits.map((itm, index) => (
                    <li key={index}>
                      <span className={`${itm.icon} appendRight10`}></span>
                      <span className="font14 lineHeight18 darkGreyText">{itm.text}</span>
                    </li>
                  ))}
              </ul>
              <p className="selectExstngAgrmnt-benefits-text">
                * All benefits will be treated as commission and TDS as per slab will be withheld on
                these benefits
              </p>
            </>
          )}
          {selectExstngAgrmnt.continueBkngBtn && (
            <a className="continueBkngBtn" href={selectExstngAgrmnt.continueBkngBtn.routePath}>
              {selectExstngAgrmnt.continueBkngBtn.title}
            </a>
          )}
          {(selectExstngAgrmnt.prmyBtnObj ||
            selectExstngAgrmnt.tertiaryBtnObj ||
            selectExstngAgrmnt.agreeStatement ||
            selectExstngAgrmnt.enrollBenefitText ||
            userData?.email?.value) && (
            <div className="selectExstngAgrmnt-btns margin-class">
              {/*userData?.email?.value && pageIndex == 'new-agreement-acknowledged-page' && (
                <p className="newAgrmntSentEmail">
                  A copy of your termination and new agreement has been sent to{' '}
                  <span className="latoBold">{userData?.email?.value}</span>
                </p>
              )*/}
              {selectExstngAgrmnt.enrollBenefitText && (
                <p className="enrollBenefitText">
                  To enrol for the additional benefits later, visit the{' '}
                  <a className="latoBlack" onClick={handleSettingsRedirection}>
                    My Profile
                  </a>{' '}
                  section for details
                </p>
              )}
              {selectExstngAgrmnt.agreeStatement && (
                <p className="agreeStatement">
                  We have updated our{' '}
                  <a onClick={e => getLoyaltyAgreementContract()}>partner agreement </a> to reward
                  you with various benefits. The new agreement will be effective from{' '}
                  <span className="latoBlack">1st April 2023</span>
                  {/* <span className="latoBlack">
                    {loyaltyAgreementDate?.loyaltyAgreementDate?.agn_termination_date}
                  </span>{' '}
                  and the <a onClick={e => getLoyaltyAgreementContract()}>new agreement</a> with
                  additional benefits will activate on{' '}
                  <span className="latoBlack">
                    {loyaltyAgreementDate?.loyaltyAgreementDate?.ang_start_date}
                  </span> */}
                </p>
              )}
              {(selectExstngAgrmnt.prmyBtnObj || selectExstngAgrmnt.tertiaryBtnObj) && (
                <p className="makeFlex hrtlCenter vrtlCenter fullWidth">
                  {!userData?.tnc_completed?.is_mandatory && selectExstngAgrmnt.tertiaryBtnObj && (
                    <button
                      className="tertiaryBtn"
                      onClick={e =>
                        submitHandlerForTertiaryButton(selectExstngAgrmnt.tertiaryBtnObj.title)
                      }
                    >
                      {' '}
                      {selectExstngAgrmnt.tertiaryBtnObj.title}{' '}
                    </button>
                  )}
                  {selectExstngAgrmnt.prmyBtnObj && (
                    <button
                      onClick={e =>
                        submitHandlerForPrimaryButton(selectExstngAgrmnt.prmyBtnObj.title)
                      }
                      className="primaryBtn"
                    >
                      {selectExstngAgrmnt.prmyBtnObj.title}
                    </button>
                  )}
                </p>
              )}
            </div>
          )}
        </div>
      )}
    </S.styledDiv>
  );
};

export default SelectTnC;

export const NavigationSection = ({backBtn, expiryInfo, stepTrack, step}) => {
  return (
    <div className="makeFlex hrtlCenter appendBottom20 ">
      {backBtn && (
        <a href="/AgreementChangeFlow" className="makeFlex hrtlCenter cursorPointer">
          <span className="backArrow"></span>
          <span className="blackText font12 latoBold appendLeft6">BACK</span>
        </a>
      )}
      {expiryInfo && <p className="expiryInfo" dangerouslySetInnerHTML={{__html: expiryInfo}} />}
      {stepTrack && (
        <p className="makeFlex column appendLeft10">
          <span className="stepTrack" dangerouslySetInnerHTML={{__html: stepTrack}} />
          <span className={`stepTrackBar stepTrackBar${step}`}></span>
        </p>
      )}
    </div>
  );
};
